import fetchEmails from '../Services/fetchEmails'

export default () => (dispatch) => {

  dispatch(fetchEmails())

}
